@if (isRunnerEnabled()) {
  <div class="callout callout-primary mb-4" i18n>Some jobs are also processed by <a routerLink="/admin/settings/system/runners/jobs-list">remote runners</a>.</div>
}

<my-table
  #table
  key="JobsComponent"
  dataKey="uniqId"
  [defaultColumns]="columns"
  i18n-paginatorText
  paginatorText="jobs per page"
  columnConfig="true"
  [dataLoader]="dataLoader"
  [inputFilters]="inputFilters"
  refreshButton="true"
>
  <ng-template #totalTitle let-totalRecords>
    <ng-container i18n>{ totalRecords, plural, =0 {No job} =1 {1 job} other {{{ totalRecords | myNumberFormatter }} jobs}}</ng-container>
  </ng-template>

  <ng-template #tableCells let-job>
    @if (table.isColumnDisplayed('id')) {
      <td class="job-id" [title]="job.id">{{ job.id }}</td>
    }

    @if (table.isColumnDisplayed('type')) {
      <td class="job-type">
        <a routerLink="." [queryParams]="{ type: job.type }" [title]="getTypeFilterTitle(job.type)" class="pt-badge ellipsis" [ngClass]="getRandomJobTypeBadge(job.type)">{{ job.type }}</a>
      </td>
    }

    @if (table.isColumnDisplayed('priority')) {
      <td class="job-priority">{{ job.priority }}</td>
    }

    @if (table.isColumnDisplayed('state') && table.isColumnDisplayed('state')) {
      <td class="job-state">
        <a
          routerLink="."
          [queryParams]="{ state: job.state }"
          class="ellipsis"
          [ngClass]="getJobStateClasses(job.state)"
          [title]="getStateFilterTitle(job.state)"
        >{{ job.state }}</a>
      </td>
    }

    @if (table.isColumnDisplayed('progress')) {
      <td class="job-progress">
        @if (hasProgress(job)) {
          {{ getProgress(job) }}
        }
      </td>
    }

    @if (table.isColumnDisplayed('createdAt')) {
      <td class="job-date">{{ job.createdAt }}</td>
    }

    @if (table.isColumnDisplayed('processed')) {
      <td class="fs-7">
        <div>{{ job.processedOn }}</div>
        <div>{{ job.finishedOn }}</div>
      </td>
    }
  </ng-template>

  <ng-template #expandedRow let-job>
    <div>
      <pre>{{ [
        'Job: ' + job.id,
        'Type: ' + job.type,
        'Processed on ' + (job.processedOn || '-'),
        'Finished on ' + (job.finishedOn || '-')
      ].join('\n') }}</pre>
    </div>

    <div>
      <pre>{{ job.data }}</pre>
    </div>

    <div>
      <pre>{{ job.error }}</pre>
    </div>
  </ng-template>

  <ng-template #noResults let-search="search" let-filters="filters">
    <div>
      @if (search || filters) {
        <ng-container i18n>No job found for the current filters.</ng-container>
      } @else {
        <ng-container i18n>No job found.</ng-container>
      }
    </div>
  </ng-template>
</my-table>
